import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAnnotationEvents } from '../../../redux/actions';
import { Box, Paper, Typography } from '@mui/material';

export default function Events({ project }) {

  const events = useSelector(state => state.cada.ann_events);
  const eventCount = useSelector(state => state.cada.ann_events_count);

  const dispatch = useDispatch();

  const user = useSelector(state => state.main.user);

  useEffect(() => {
    if (project?.id && user?.id) {
      dispatch(getAnnotationEvents(
        project.id,
        user.id
      ));

    }
  }, [dispatch, project, user]);

  console.log("Events", events, eventCount);

  return (
    <>
      <Paper
        sx={{
          p: 2,
          borderRadius: 4,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Typography variant="h5">
          {eventCount?.[project.id]?.[0] + eventCount?.[project.id]?.[1]} Events
        </Typography>
      </Paper>

      {events && events?.[project.id] && (
        <>
          {[...events[project.id][false], ...events[project.id][true]].slice(0, 3).map((e) => (
            <Box
              key={e.id}
              sx={{
                p: 1,
                mt: 2,
                borderRadius: 4,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h5">
                {e.cadaFile.path}
              </Typography>
            </Box>
          ))}
          <Typography variant="h5">...</Typography>
          {[...events[project.id][false], ...events[project.id][true]].slice(-3).map((e) => (
            <Box
              key={e.id}
              sx={{
                p: 1,
                mt: 2,
                borderRadius: 4,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography variant="h5">
                {e.cadaFile.path}
              </Typography>
            </Box>
          ))}
        </>
      )}
    </>
  )
};
